import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'uploadsProcessed',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Uploads Processed',
  },
}

const keys = {
  statKey: 'uploads_processed',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const uploadsProcessed = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { uploadsProcessed }
